import $ from 'jquery';
import {getScrollTop} from "../utils/window";

export default function modalSection() {
	const $html = $('html');
	const $htmlAndBody = $('html, body');
	const $modal = $('#modal');
	const $iframe = $modal.find('iframe');
	const toggler = $modal.data('toggler');

	let st = 0;
	if (toggler) {

		$iframe.on('load', function() {
			try {
				const href = $iframe[0].contentWindow.location.href
				const isBlank = href === 'about:blank';
				toggler.toggle(!isBlank);

			} catch(e) {
				toggler.close();
			}
		});

		$modal.on('click', function(e) {
			if (e.target === this) {
				toggler.close();
			}
		});

		toggler.on('toggle', function() {
			$html.toggleClass('is-modal-open', toggler.isOpen);

			if (toggler.isOpen) {
				st = getScrollTop();

				$htmlAndBody.css({
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%'
				});
			} else {

				$htmlAndBody.css({
					position: '',
					top: '',
					left: '',
					width: '',
					height: ''
				});

				if (st) {
					$htmlAndBody.scrollTop(st);
					st = 0;
				} else {
					$htmlAndBody.scrollTop(0);
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/modal.js